"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { guesterAccountBindAPI } from "@/shared/api/guester-account-bind/guester-account-bind.api";
export class GuesterAccountBindService {
  //匿名登陆并绑定当前clientId产生的token
  ghostLogin(account, password) {
    return __async(this, null, function* () {
      let clientId = localStorage.getItem("_cid");
      const newAccountInfo = yield guesterAccountBindAPI.ghostAccountBind(clientId, account, password);
      localStorage.removeItem("_cid");
      localStorage.setItem("token", newAccountInfo.token);
    });
  }
}
